var CrowdAlert = require('./crowd-alert')

module.exports = Backbone.Collection.extend({
	model: CrowdAlert,

	url: function() {
		return App.alertsRoot + 'crowd/alerts/reported'
	}
})
